import { render, staticRenderFns } from "./SciencePatentArticles.vue?vue&type=template&id=95deac4e&scoped=true"
import script from "./SciencePatentArticles.vue?vue&type=script&lang=js"
export * from "./SciencePatentArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95deac4e",
  null
  
)

export default component.exports